import type { ProjectOutput } from 'core/http/dev';
import { createAction, props } from '@ngrx/store';

export const getAssignedProjects = createAction('[Assigned Projects Request] Get Assigned Projects');
export const saveAssignedProjectsInState = createAction('[Assigned Projects State] Save Assigned Projects In State', props<{ projects: ProjectOutput[] }>());
export const markAssignedProjectsLoaded = createAction('[Assigned Projects State] Mark Assigned Projects Loaded');

export const resetAssignedProjects = createAction('[Assigned Projects State] Reset Assigned Projects');
